import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      <span className="footer">2018 Copyright &copy; WE CARE. All Rights Reserved. </span>
    </footer>
  )
}


export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js